import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { ReportService } from '../../_service/report.service';
import { SharedService } from '../../_service/shared.service';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {formatDate} from '@angular/common';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-lead-keywords',
  templateUrl: './lead-keywords.component.html',
  styleUrls: ['./lead-keywords.component.css']
})
export class LeadKeywordsComponent implements OnInit {

  perpage:number=25;leads:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;leadStatus=[];loaded:boolean=false;circles=[];circle='';
    search:string;lead_source:string;lead_status:string;start_date:string='';end_date:string='';treatments=[];leadStatus_copy=[];circles_copy=[];treatments_copy=[];
    submitted:boolean=false;s3url:string='';
    
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    
    constructor(private leadapi:LeadsService,private sharedapi:SharedService,private reportapi:ReportService) { }

    ngOnInit(): void 
    {
        this.getcircle();
        this.getleadStatus();this.getTreatment();
        this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.s3url = localStorage.getItem('s3url');
    }

    ngAfterViewInit() {
         this.loadleads(0,this.perpage);
    }

    setSearchValue(type){
        if(type=='lead_status'){
            $("#lead_status_Search").val('');
            $("#lead_status_Search").focus();
            this.leadStatus= this.leadStatus_copy;
        }else if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'lead_status') {
            this.leadStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
        }else  if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else  if (type == 'treatment') {
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }


    async loadleads(pageIndex,perpage)
    {
        this.leads = [];
        this.paginator.pageIndex = pageIndex; 
        let qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&lead_source='+this.lead_source+'&date_range='+this.start_date+'-'+this.end_date;
        this.loading = true;this.loaded = false;
        this.reportapi.getLeadKeywordReport(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.leads = data.data;
            }else{
                this.leads = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadleads(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadleads(event.pageIndex,event.pageSize);
    }

    async getleadStatus()
    {
        await this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadStatus = data.data;
                this.leadStatus_copy = this.leadStatus;
            }else{
                this.leadStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy = this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            this.loadleads(0,this.perpage);
        }
    }
    
    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.loadleads(0,this.perpage);
    }

    exportLeadKeywordReport()
    {
        if(this.leads.length>0)
        {
            let data = [];
            data.push(['Lead Status','Lead Mobile','Lead City','Circle','Treatment','Lead Time','Lead Source','Lead Keyword','Description']);
            for(let key in this.leads)
            {
                data.push([this.leads[key].lead_status_name,this.leads[key].mobile,this.leads[key].city_name,this.leads[key].circle_name,this.leads[key].treatment_name,
                  formatDate(this.leads[key].lead_time*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),this.leads[key].zoho_lead_source,this.leads[key].keywords,this.leads[key].description])
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
          /* generate workbook and add the worksheet */
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

          /* save to file */
          let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
          XLSX.writeFile(wb, 'leadkeywords'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }
}
